// Capitaliza o primeiro caractere de cada palavra em uma string.
// Exceção: palavras com comprimento entre 1 e 3 (inclusive) são deixadas inalteradas.
function capitalize(
	input: string | undefined,
	firstOnly: boolean = false,
): string {
	if (!input) return 'n/a'

	if (firstOnly) {
		return input.length > 0 ? input[0].toUpperCase() + input.slice(1) : input
	}

	return input
		.split(' ')
		.map((word) => {
			if (word.length === 0) return word // preserva espaços consecutivos
			if (word.length <= 2) return word // palavra curta: não capitaliza

			const first = word[0].toUpperCase()
			const rest = word.slice(1)
			return first + rest
		})
		.join(' ')
}

export { capitalize }
